<template>
  <div class="myAssess">
    <component :is="dialogConfig.name" :dialogConfig="dialogConfig" @cancleDialog="cancleDialog(arguments)"></component>
    <ul class="tabs">
      <li @click="changeTabs(items.index)" :class="items.index == tabs ? 'active':'' " v-for="items in classData" :key="items.id">{{items.title}}</li>
    </ul>
    <ul class="myAssessContents" v-if="this.tabs == 0">
      <template v-if="this.data.length>0">
        <li v-for="(item, i) in this.data" :key="i">
          <div class="classImages">
            <span class="iconfont notstart" v-if="item.status == 1">未开始</span>
            <span class="iconfont inProgress" v-if="item.status == 2">进行中</span>
            <span class="iconfont completed" v-if="item.status == 3">已完成</span>
            <span class="iconfont expired" v-if="item.status == 4">已过期</span>
            <img :src="item.photo" alt />
          </div>
          <div class="classInfo">
            <div :class="item.status == 4? 'info gray':'info'">
              <h3>{{item.name}}</h3>
              <p class="answerlimit">
                <img src="../../../assets/limit-2.png" alt="" v-if="item.is_start == 2">
                <img src="../../../assets/limit-1.png" alt="" v-else>
                <span class="limit">答题次数：</span>
                <span v-if="item.limit_type == 1">剩余1次</span>
                <span v-else>不限</span>
              </p>
              <p class="period" v-if="item.expire_date != 0">
                <span>有效期：</span>
                <span>{{item.start_time}} —— {{item.end_time}}</span>
              </p>
            </div>
            <div class="rightButtom">
              <a-button class="startAssess" type="primary" shape="round" v-if="item.can_start==1 && (item.status!='4')" @click="startAssess(item.id, item.class_id)">开始测评</a-button>
            </div>
          </div>
        </li>
      </template>
      <div v-else class="noData-box">
        <img src="@/assets/empty.png" alt="">
        <div class="text">暂无相关内容</div>
      </div>

    </ul>
    <div class="pages" id="pages1" v-if="this.tabs==0">
      <a-pagination :defaultPageSize="5" @change="onChange1" :locale="zhCN" :default-current="1" :total="this.num" />
    </div>
    <div>
      <ul class="assessLoglists" v-if="this.tabs == 1">
        <a-table :columns="columns" :data-source="Loglists" :rowKey="(record, index) => {return index}" class="table" :pagination="false">
          <template slot="score" slot-scope="text, record">
            {{ record.is_assess == 1 ? record.score : '待评分' }}
          </template>
          <template slot="operation" slot-scope="text, record">
            <a-button class="button" type="primary" shape="round" @click="assessResult(record)">测评结果</a-button>
          </template>
        </a-table>
        <div class="pages" v-if="this.Loglists.length > 0" id="pages2">
          <a-pagination :defaultPageSize="10" @change="onChange" :locale="zhCN" :default-current="1" :total="this.LoglistsNum" />
        </div>
        <div v-if="!this.Loglists.length" class="noData-box">
          <img src="@/assets/empty.png" alt="">
          <div class="text">暂无相关内容</div>
        </div>
      </ul>
    </div>

  </div>
</template>

<script>
import zhCN from "ant-design-vue/es/locale-provider/zh_CN";
import services from "../../../config/services";
import { Pagination, Table, Button } from "ant-design-vue";
import { mapState } from "vuex";
const classData = [
  {
    index: 0,
    id: 1,
    title: "我的测评",
  },
  {
    index: 1,
    id: 2,
    title: "测评记录",
  }
];
const columns = [
  {
    title: '测评名称',
    dataIndex: 'exam_name',
    // key: 'exam_name',
  },
  {
    title: '完成时间',
    dataIndex: 'finish_time',
    // key: 'finish_time',
    align: 'center'
  },
  {
    title: '得分',
    dataIndex: 'score',
    // key: 'score1',
    align: 'center',
    scopedSlots: { customRender: "score" },
  },
  {
    title: '用时',
    dataIndex: 'duration',
    // key: 'duration1',
    align: 'center',
    scopedSlots: { customRender: "duration" },
  },
  {
    title: '操作',
    // key: 'operation',
    dataIndex: "operation",
    align: 'center',
    scopedSlots: { customRender: "operation" },
  }
]
export default {
  name: "myAssess",
  components: {
    APagination: Pagination,
    ATable: Table,
    AButton: Button,
    assessInfo: () => import("./assessInfo.vue")
  },
  data () {
    return {
      classData,
      zhCN,
      services: services,
      tabs: 0,
      data: [],
      num: 0,
      columns,
      dialogConfig: {
        name: '',
        title: '',
        data: null,
        dialogVisible: true,
      },
      assessData: null,
      Loglists: [],
      LoglistsNum: 0,
    }
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    })
  },
  created () {
    if(this.$route.query.tabs){
      this.tabs = this.$route.query.tabs
    }
    if (this.tabs == 0) {
      this.data = [];
      this.lodAssessList({
        page: 1
      });
    } else if(this.tabs == 1) {
      this.data = [];
      this.assessLoglists({
        page: 1
      });
    }
  },
  methods: {
    //测评记录分页
    onChange (pageNumber) {
      this.assessLoglists({
        page: pageNumber
      });
    },
    //我的测评分页
    onChange1 (pageNumber) {
      this.lodAssessList({
        page: pageNumber
      });
    },
    //关闭弹框
    cancleDialog (val) {
      this.dialogConfig.name = null;
    },
    changeTabs (index) {
      this.tabs = index;
      let routeData = this.$router.resolve({
        path: `/${this.loginUserInfo && this.loginUserInfo.school_code}/user/myAssess`,
        query: {
          tabs: index,
        },
      });
      window.open(routeData.href, '_self');
    },
    lodAssessList (params) {
      services
        .assessList({
          page: 1,
          size: 5,
          ...params,
        }).then((res) => {
          if (res.code === "0000") {
            this.data = res.data.items;
            this.num = res.data.total;
          }
        })
    },
    assessLoglists (params) {
      services
        .assessLoglists({
          page: 1,
          size: 10,
          ...params,
        }).then((res) => {
          if (res.code === "0000") {
            this.Loglists = res.data.items;
            this.LoglistsNum = res.data.total;
          }
        })
    },
    assessGet (ass_id, class_id) {
      services
        .assessGet({
          id: ass_id,
          data: {
            class_id: class_id
          }
        }).then((res) => {
          if (res.code == "0000") {
            this.assessData = res.data;
            this.dialogConfig.data = this.assessData;
            this.dialogConfig.name = 'assessInfo';
            this.dialogConfig.title = "提示";
          }
        })
    },
    assessResult (params) {
      // console.log(params)
      this.$router.push({
        //跳转到再次测评
        path:  `/${this.loginUserInfo && this.loginUserInfo.school_code}/user/myAssess/againAssess`,
        query: {
          ass_id: params.exam_id,
          assessName: params.exam_name,
          record_id: params.id,
          class_id: params.class_id,
          tabs: 1,
        }
      });

    },
    startAssess (ass_id, class_id) {
      this.assessGet(ass_id, class_id);
    }
  },

}
</script>

<style lang="less" scoped>
.myAssess {
  #pages1 {
    display: flex;
    margin-bottom: 20px;
    justify-content: center;
  }
  .myAssessContents {
    .classInfo {
      height: 173px;
      .rightButtom {
        .startAssess:hover {
          background: #134bce;
        }
      }
      .info {
        .answerlimit {
          font-size: 13px;
          margin-top: 10px;
          color: #969696;
          img {
            margin-top: 3px;
            margin-right: 10px;
            width: 14px;
          }
        }
        .period {
          font-size: 13px;
          color: #4d555d;
          margin-top: 30px;
        }
      }
      .gray {
        color: #c5c6cd;
        h3,
        p,
        span {
          color: #c5c6cd;
        }
      }
    }
    .classImages {
      .inProgress,
      .notstart,
      .completed,
      .expired {
        position: absolute;
        left: 0;
        border-radius: 0 0 8px 0;
        font-size: 12px;
        padding: 4px 8px;
      }
      .inProgress {
        background: #d2f5e0;
        color: #06ca37;
      }
      .notstart {
        background: #d4e3fc;
        color: #1466fc;
      }
      .completed {
        background: #e7d2f5;
        color: #9a3bec;
      }
      .expired {
        background: #b1b4bb;
        color: #ffffff;
      }
    }
  }
  .assessLoglists {
    #pages2 {
      display: flex;
      margin-bottom: 20px;
      justify-content: center;
    }
    .table {
      margin-top: 25px;
      /deep/.ant-table-thead > tr > th {
        background: #e9f1fd;
        font-weight: bold;
        color: #333;
      }
      /deep/.ant-table-thead > tr:first-child > th:last-child {
        border-top-right-radius: 0px;
      }
      /deep/.ant-table-thead > tr:first-child > th:first-child {
        border-top-left-radius: 0px;
      }
      /deep/.ant-table-tbody tr:hover td {
        background: #f6f6f6;
      }
      .button {
        background: #2462f5;
      }
      .button:hover {
        background: #134bce;
      }
    }
  }
}
::v-deep .ant-empty {
  display: none;
}

.noData-box {
  width: 100%;
  text-align: center;
  height: 770px;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 150px;
  img {
    width: 240px;
    height: auto;
    margin: 0 auto 30px;
  }
  .text {
    color: #76797e;
    font-size: 14px;
  }
}
</style>